<template>
  <emd-modal
    has-header
    footer-buttons-on-right
    :open="isModalOpen"
    @close="handleClose"
  >
    <template #header>
      <emd-text>
        {{ $t('title') }}
      </emd-text>
    </template>

    <template #content>
      <component
        v-if="computedStepComponents"
        :is="computedStepComponents"
        :key="computedStepComponents"
        :isLoading="isLoading"
        :authError="authError"
        @create="handleCreate"
        @submit="handleSubmit"
        @close="handleClose"
        @back="handleBack"
      ></component>
    </template>
  </emd-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { EmdModal, EmdText } from 'emerald-vue/src/components'
import CREATE_KEY_STEPS_ENUM from '../../enums/create-keys-steps.enum'

import { isPreconditionFailed } from '@/enums/http-status.enum'

export default {
  name: 'ModalCreateKeyContent',

  components: {
    EmdModal,
    EmdText,
    CreateKey: () => import('./CreateKey.vue'),
    AllKey: () => import('./AllKey.vue'),
    CustomKey: () => import('./CustomKey.vue')
  },

  props: {
    isModalOpen: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isLoading: false,
      authError: false,
      form: {}
    }
  },

  computed: {
    computedStepComponents () {
      return (
        CREATE_KEY_STEPS_ENUM[this.form?.type] ?? CREATE_KEY_STEPS_ENUM.create
      )
    }
  },

  methods: {
    ...mapActions(['CREATE_SECRET_KEY']),

    handleBack (scope) {
      this.isLoading = false
      this.authError = false
      this.form.type = scope
    },

    handleClose () {
      this.$emit('handleClose')
    },

    handleCreate (form) {
      this.form = form
    },

    handleSubmit (form) {
      const payload = { ...form, ...this.form }

      this.isLoading = true

      const body = {
        name: payload.name,
        password: window.btoa(payload.password),
        is_legacy_mode: payload.isLegacy,
        scope: payload.scope
      }

      this.CREATE_SECRET_KEY(body)
        .then(res => {
          this.$emit('success', res)
          this.handleClose()
        })
        .catch(({ status }) => (this.authError = isPreconditionFailed(status)))
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<i18n>
    {
      "pt-BR": {
        "title": "Criar chave"
      },
      "en-US": {
        "title": "Create key"
      }
    }
  </i18n>
